import DocusaurusFooter from '../DocusaurusFooter'
import {
  Color,
  Paragraph
} from '@eggplant/pattern-library'
import { agentTools } from '../../docs-routes'

const AgentTools = () =>
  <>
    <Paragraph>
      <Color variant='theme-description-text'>
        Agent Tools include installers and API keys that enable you to use the Eggplant DAI Agent. First, download and install the appropriate Eggplant DAI Agent installer for your operating system. You can then create an Execution Environment and generate an Access Key to allow the Agent to authenticate.
      </Color>
    </Paragraph>
    <DocusaurusFooter path={agentTools} />
  </>

export default AgentTools
